import Vue from "vue";
import VueRouter from "vue-router";
import MainPageViewer from "./components/MainPageViewer.vue";
import DashboardPage from "./pages/DashboardPage.vue";
import LoginPage from "./pages/LoginPage.vue";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  routes: [
    { path: "/", component: MainPageViewer },
    { path: "/pages/:page?", component: MainPageViewer },
    { path: "/login", component: LoginPage },
    {
      path: "/dashboard/:page?",
      component: DashboardPage,
      meta: {
        // 通过添加requiresAuth这个meta来标记需要登录保护的页面
        requiresAuth: true,
      },
    },
  ],
});
// 需要登录的页面检测是否有token
// 有则通过，否则跳转到登录页面
// 不需要登录的页面就直接访问
router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    const token = localStorage.getItem("token");
    if (token) {
      next();
    } else {
      next("/login");
    }
  } else {
    next();
  }
});
export default router;
